import React, { useEffect, useState } from "react";
import { Grid, Typography, TextField, Button } from "@mui/material";
import instance from "../../utils/api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useParams } from "react-router-dom";
import resetpassword from '../../Assets/resetpassword.svg'

function AdminResetNewPassword() {
  const { email } = useParams();
  const navigate = useNavigate();
  const [confirmPassword, setConfirmPassword] = useState();
  const [newPassword, setNewPassword] = useState();
  const [otp, setOtp] = useState();

  const fetchNewlyResetpassword = async () => {
    try {
      const response = await instance.post("/vendor/ResetPasswordOTP", {
        email: email,
        newPassword,
        confirmPassword,
        otp,
      });
      if (response.status === 200) {
        toast.success(response.data.msg);
        navigate("/");
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchNewlyResetpassword();
  }, [email]);

  return (
    <>
      <React.Fragment>
        <section className="admin_login">
          <div className="login">
            <Grid container direction="column" spacing={3}>
              <Typography variant="h2"><img src={resetpassword} /></Typography>
              <Typography>Enter otp</Typography>
              <form className="new-password-form">
                <Grid item>
                  <TextField
                    type="email"
                    label="Enter Your Email"
                    placeholder="Email Address"
                    variant="outlined"
                    // autoComplete='off'
                    required
                    fullWidth
                    value={email}
                  />
                </Grid>
                <Grid item>
                  <TextField
                    type="new password"
                    label="new password"
                    placeholder="enter new password"
                    variant="outlined"
                    // autoComplete='off'
                    required
                    fullWidth
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                </Grid>
                <Grid item>
                  <TextField
                    type="confirm password"
                    label="confirm password"
                    placeholder="enter confirm password"
                    variant="outlined"
                    // autoComplete='off'
                    required
                    fullWidth
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                </Grid>
                <Grid item>
                  <TextField
                    type="otp"
                    label="Enter Your OTP"
                    placeholder="OTP"
                    variant="outlined"
                    //   autoComplete='off'
                    required
                    fullWidth
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                  />
                </Grid>
                <Grid item>
                  <Button
                    className="sent-otp-btn"
                    variant="contained"
                    onClick={fetchNewlyResetpassword}
                  >
                    Confirm
                  </Button>
                </Grid>
              </form>
            </Grid>
          </div>
        </section>
      </React.Fragment>
    </>
  );
}

export default AdminResetNewPassword;
